import React, { useEffect, useState } from "react";
import {
  Panel,
  Input,
  Table,
  Button,
  IconButton,
  InputNumber,
  SelectPicker,
  toaster,
  Message,
  Text,
  NumberInput,
} from "rsuite";
import { VscEdit, VscSave } from "react-icons/vsc";
import { FaPlus, FaSync } from "react-icons/fa";
import { LayoutMain } from "../LayoutMain";
import {
  getListServicios,
  updateServicio,
} from "../Services/CatalogosServices";

const { Column, HeaderCell, Cell } = Table;

const styles = `
.table-cell-editing .rs-table-cell-content {
  padding: 4px;
}
.table-cell-editing .rs-input {
  width: 100%;
}
`;

export const Servicios = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [data, setData] = useState([]);
  const [dataTD, setDataTD] = useState([]);

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], data);
    nextData.find((item) => item.id === id)[key] = value;
    setData(nextData);
  };

  const handleEdit = (id) => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.find((item) => item.id === id);

    activeItem.status = activeItem.status ? null : "EDIT";

    setData(nextData);
  };

  const handleChangeTD = (id, key, value) => {
    const nextData = Object.assign([], dataTD);
    nextData.find((item) => item.id === id)[key] = value;
    setDataTD(nextData);
  };

  const handleEditTD = (id) => {
    const nextData = Object.assign([], dataTD);
    const activeItem = nextData.find((item) => item.id === id);

    activeItem.status = activeItem.status ? null : "EDIT";

    setDataTD(nextData);
  };

  const loadServicios = async () => {
    await getListServicios(idNegocio)
      .then((response) => {
        setData(response);
      })
      .catch((error) => {
        if (error.status === 401) {
          toast("Debe iniciar sesión, antes de continuar...", "error");
          setTimeout(() => {
            window.location = `/`;
          }, 1200);
        } else {
          toast(error.message, "error");
        }
      });
  };

  useEffect(() => {
    loadServicios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <LayoutMain titleItem={"Servicios"}>
        <style>{styles}</style>
        <div className="p-4 max-w mx-auto bg-white rounded-xl shadow-md border border-gray-100">
          <Text weight="semibold" size={"xl"}>
            Lista de Servicios
          </Text>
          <Panel bordered>
            <div className="row">
              <div className="col">
                <>
                  <Button
                    appearance="ghost"
                    startIcon={<FaPlus></FaPlus>}
                    color="blue"
                    onClick={() => {
                      setData([
                        {
                          id: data.length + 1,
                          servicio: "",
                        },
                        ...data,
                      ]);
                    }}
                  >
                    Agregar registro
                  </Button>
                  <hr />
                  <Table
                    height={600}
                    hover={true}
                    showHeader={true}
                    data={data}
                    bordered={true}
                    cellBordered={true}
                    headerHeight={30}
                    rowHeight={40}
                  >
                    <Column flexGrow={1}>
                      <HeaderCell
                        style={{ fontWeight: "bold", fontSize: "14px" }}
                      >
                        Nombre del Servicio
                      </HeaderCell>
                      <EditableCell
                        dataKey="servicio"
                        dataType="string"
                        onChange={handleChange}
                        onEdit={handleEdit}
                      />
                    </Column>

                    <Column flexGrow={1}>
                      <HeaderCell
                        align="center"
                        style={{ fontWeight: "bold", fontSize: "14px" }}
                      >
                        Mostrar en Pantalla de inicio
                      </HeaderCell>
                      <EditableCell
                        align="center"
                        dataKey="mostrar"
                        dataType="picker"
                        onChange={handleChange}
                        onEdit={handleEdit}
                      />
                    </Column>

                    <Column width={200}>
                      <HeaderCell
                        align="right"
                        style={{ fontWeight: "bold", fontSize: "14px" }}
                      >
                        Precio
                      </HeaderCell>
                      <EditableCell
                        align="right"
                        dataKey="precio"
                        dataType="number"
                        onChange={handleChange}
                        onEdit={handleEdit}
                      />
                    </Column>

                    <Column flexGrow={1}>
                      <HeaderCell
                        align="center"
                        style={{ fontWeight: "bold", fontSize: "14px" }}
                      >
                        Activo
                      </HeaderCell>
                      <EditableCell
                        align="center"
                        dataKey="estatus"
                        dataType="picker"
                        onChange={handleChange}
                        onEdit={handleEdit}
                      />
                    </Column>

                    <Column width={100}>
                      <HeaderCell
                        align="center"
                        style={{ fontWeight: "bold", fontSize: "14px" }}
                      >
                        Acciones
                      </HeaderCell>
                      <ActionCell dataKey="id" onEdit={handleEdit} />
                    </Column>
                  </Table>
                </>
              </div>
            </div>
          </Panel>
        </div>
      </LayoutMain>
    </>
  );
};

function toValueString(value, dataType) {
  return dataType === "date" ? value?.toLocaleDateString() : value;
}

const fieldMap = {
  string: Input,
  number: NumberInput,
  picker: SelectPicker,
};

const EditableCell = ({
  rowData,
  dataType,
  dataKey,
  onChange,
  onEdit,
  ...props
}) => {
  const editing = rowData.status === "EDIT";

  const Field = fieldMap[dataType];
  const value = rowData[dataKey];
  const text = toValueString(value, dataType);

  return (
    <Cell
      {...props}
      className={editing ? "table-cell-editing" : ""}
      onClick={(event) => event.target.select()}
      onDoubleClick={() => {
        onEdit?.(rowData.id);
      }}
    >
      {editing ? (
        <Field
          defaultValue={value}
          searchable={false}
          block
          min={0}
          data={[
            { label: "SI", value: "SI" },
            { label: "NO", value: "NO" },
          ]}
          onChange={(value) => {
            onChange?.(rowData.id, dataKey, value);
          }}
        />
      ) : (
        text
      )}
    </Cell>
  );
};

const toast = (msg, type = "info") => {
  toaster.push(
    <Message showIcon type={type} closable>
      <strong>{type}!</strong>
      &nbsp; {msg}
    </Message>,
    { duration: 5000, placement: "topCenter" },
  );
};

const saveRecord = async (id, rowData, mode) => {
  if (mode === "EDIT") {
    return;
  }

  const idNegocio = JSON.parse(localStorage.getItem("auth")).id;

  const data = {
    id: idNegocio,
    idServ: rowData.id,
    servicio: rowData.servicio,
    mostrar: rowData.mostrar,
    idPrecio: rowData.idPrecio,
    precio: rowData.precio,
    estatus: rowData.estatus,
  };

  await updateServicio(data)
    .then(async (res) => {
      if (res.data === 1) {
        toast("El registro se ha actualizado de forma correcta", "success");
        setTimeout(() => {
          window.location.reload();
        }, [600]);
      } else {
        toast("No se ha registrado la información", "warning");
      }
    })
    .catch((error) => {
      toast("Ha ocurrido un error inesperado.", "error");
      console.log(error);
    });
};

const ActionCell = ({ rowData, dataKey, onEdit, onRemove, ...props }) => {
  return (
    <Cell
      {...props}
      style={{ padding: "6px", display: "flex", gap: "4px" }}
      align="center"
    >
      <IconButton
        appearance="subtle"
        icon={rowData.status === "EDIT" ? <VscSave /> : <VscEdit />}
        onClick={() => {
          onEdit(rowData.id);
          saveRecord(rowData.id, rowData, rowData.status);
        }}
      />
    </Cell>
  );
};
